<div class="addcase-container" >
    <div class="dwform dwform-cell-nopadding" style="min-width: 500px;">

        <div class="dwform-row">
            <div class="dwform-row-gap"></div>
            <label class="label-field">Case Number:</label>
            <span class="form-required"></span>
            <label class="label-field-data">{{caseNumber}}</label>
            <div style="display: inline-flex; width:75px;text-align: right">   </div>
        </div>
        <div class="dwform-row-gap"></div>
        <mat-divider></mat-divider>
        <div class="section-header">
            <span matTooltipPosition="after" matTooltip="Primary recipient for services">Applicant Name:</span>
        </div>
        <div class="dwform-row">
                <label class="label-field">First:</label>
                <span class="form-required">*</span>
                <input class="input-field" id="firstNameId"
                       [(ngModel)]="firstName"
                       style="text-transform: capitalize;width: 170px"
                       placeholder="<First Name>"
                       type="text">

            <label class="label-field-half">Middle:</label>
            <span class="form-required"> </span>
            <input class="input-field" id="middleNameId"
                   [(ngModel)]="middleName"
                   style="text-transform: capitalize;width: 170px"
                   placeholder="<Middle Name>"
                   type="text">

                <label class="label-field-half">Last:</label>
                <span class="form-required">*</span>
                <input class="input-field" id="lastName"
                       [(ngModel)]="lastName"
                       style="text-transform: capitalize;width: 170px"
                       placeholder="<Last Name>"
                       type="text">
        </div>

        <div class="dwform-row-gap"></div>

        <label class="label-field">Date of Birth:</label>
        <span class="form-required">*</span>
        <input class="input-field" id="dobId"
               matTooltip="Format is 'YYYY-MM-DD'"
               mask="9999-99-99" [dropSpecialCharacters]="false"
               showMaskTyped="true"
               (focusout)="doDOBFocusOut($event)"
               [(ngModel)]="dob"
               style="text-transform: capitalize;width: 80px"
               placeholder="<DOB>"
               type="text">

        <label style="display: inline-block; width:90px"> </label>
        <label class="label-field-half">Gender:</label>
        <span class="form-required">*</span>

        <dw-dropdown
                [id]="'genderId'"
                [useStatusOptions]="'genderItems'"
                [controlWidth]="'170px'"
                [selectedItem]="gender" (itemSelected)="gender = $event"></dw-dropdown>

        <label style="display: inline-block; width:65px"> </label>

        <!--

        <button mat-button class="command-button" style="scale: 95%"
                (click)="doDuplicateCheck()"
            matTooltip="Check to see if the applicant already exists">
            <mat-icon>check_circle_outline</mat-icon>
            Check
        </button>

        <img src="./assets/greenTick.png" *ngIf="isUniqueMember === true"/>
        -->
        <div class="dwform-row-gap"></div>

        <mat-divider></mat-divider>
        <div class="section-header" >
            <span matTooltipPosition="after"matTooltip="Person responsible for interacting on behalf of the applicant">Advocate:</span>
            <label class="label-field-half" style="width:68px;"></label>
            <mat-checkbox [(ngModel)]="useAdvocate" (change)="doAdvocateChange($event)"></mat-checkbox>
        </div>

        <div class="dwform-row">
            <label class="label-field">First:</label>
            <span class="form-required">*</span>
            <input class="input-field" id="advocateFirstNameId"
                   [(ngModel)]="advocateFirstName"
                   [disabled]="!useAdvocate"
                   style="text-transform: capitalize;width: 170px"
                   placeholder="<First Name>"
                   type="text">

            <label class="label-field-half">Middle:</label>
            <span class="form-required"> </span>
            <input class="input-field" id="advocateMiddleNameId"
                   [(ngModel)]="advocateMiddleName"
                   [disabled]="!useAdvocate"
                   style="text-transform: capitalize;width: 170px"
                   placeholder="<Middle Name>"
                   type="text">

            <label class="label-field-half">Last:</label>
            <span class="form-required">*</span>
            <input class="input-field" id="advocatelastName"
                   [(ngModel)]="advocateLastName"
                   [disabled]="!useAdvocate"
                   style="text-transform: capitalize;width: 170px"
                   placeholder="<Last Name>"
                   type="text">
        </div>

        <div class="dwform-row-gap"></div>

        <div class="dwform-row">

        <label class="label-field">Phone Number:</label>
        <span class="form-required">*</span>

        <input class="input-field" id="advocatePhoneNumber"
               mask="(999) 999-9999" [dropSpecialCharacters]="false"
               showMaskTyped="true"
               [disabled]="!useAdvocate"
               [(ngModel)]="advocatePhone" style="width: 110px" type="text" />

        <span style="margin-left:60px"></span>
        <label class="label-field-half">Email:</label><span class="form-required"></span>

        <input class="input-field" id="advocateEmail"
               [(ngModel)]="advocateEmail"
               [disabled]="!useAdvocate"
               placeholder="<Advocate Email Address>"
               type="text" />
        <div class="dwform-row-gap"></div>



            <mat-divider></mat-divider>

        <div class="section-header">Address/Contact:</div>

        <div style="display: inline-block; width:50%; ">
        <div class="dwform-row">
                <label class="label-field">Address:</label>
                <span class="form-required">*</span>
                <input class="input-field-longest" id="address1"
                       [(ngModel)]="address1"
                       style="width: 300px;text-transform: capitalize"
                       placeholder="<Address line 1>"
                       type="text">

            <div class="dwform-row">
                <div class="dwform-row-gap"></div>

                <label class="label-field"></label>
                <span class="form-required"></span>
                <input class="input-field-longest" id="address2"
                       [(ngModel)]="address2"
                       style="width: 300px;text-transform: capitalize"
                       type="text">
        </div>
        <div class="dwform-row-gap"></div>
        <div class="dwform-row">
                <label class="label-field"></label>
                <span class="form-required"></span>

                <input class="input-field" id="city"
                       style="width: 190px;text-transform: capitalize"
                       onkeydown="return /[a-z, ]/i.test(event.key)"
                       onblur="if (this.value == '') {this.value = '';}"
                       onfocus="if (this.value == '') {this.value = '';}"
                       [(ngModel)]="city"
                       placeholder="<City>"
                       type="text">

                <input class="input-field-shortest" id="state"
                       maxLength="2"
                       mask="SS"
                       style="width:30px;text-transform: uppercase"
                       [(ngModel)]="state"
                       placeholder=""
                       type="text">

                <input class="input-field-shortest" id="zipCode"
                       [(ngModel)]="zipCode" style="width: 60px"
                       mask="99999" [dropSpecialCharacters]="false"
                       showMaskTyped="false"
                       placeholder="<Zip>"
                       type="text">

        </div>   <!-- end group -->
        <div class="dwform-row-gap"></div>
    </div>
    </div>
        <div style="display: inline-block; width:50%;">
            <div class="dwform-row">

                <label class="label-field">Primary Phone:</label>
                <span class="form-required">*</span>

                <input class="input-field" id="phoneNumber"
                       mask="(999) 999-9999" [dropSpecialCharacters]="false"
                       showMaskTyped="true"
                       [(ngModel)]="phoneNumber" style="width: 110px" type="text" />

                <div class="dwform-row-gap"></div>

                <label class="label-field">Email:</label><span class="form-required">*</span>
                <input class="input-field" id="emailAddress"
                       [(ngModel)]="emailAddress"
                       placeholder="<Email Address>"
                       type="text">

                <div class="dwform-row-gap"></div>

                <label class="label-field">County:</label>
                <span class="form-required">*</span>

                <dw-dropdown
                        [id]="'countyId'"
                        [dataSource]="countyList"
                        [controlWidth]="'200px'"
                        [selectedItem]="county" (itemSelected)="county = $event"></dw-dropdown>

                <div class="dwform-row-gap"></div>
            </div>
        </div>
        <mat-divider></mat-divider>

        <div style="display: flex;width:100%; height:250px;padding-top:7px;">

             <div class="current-need-div-style">
                 <span>Describe the Current Need / Crisis:</span>
                 <div class="dwform-row-gap"></div>
                 <textarea class="text-area-input text-area-override"
                           [(ngModel)]="currentNeed"
                           id="currentNeed" type="text" ></textarea>

                 <div class="dwform-row-gap"></div>
                 <mat-checkbox [(ngModel)]="matchAttempt">
                     Attempt to match services with my agency
                 </mat-checkbox>
             </div>

            <!-- RHC --->
            <div class="service-list-div-style">
                <span>Choose Needed Services:</span>
                <div class="dwform-row-gap"></div>
                <div class="table-container request-type-table-container"
                    tabindex="-1" (keydown)="tableKeyDown($event)">

                    <table mat-table [dataSource]="dataSource"  >
                        <!--Select -->
                        <ng-container matColumnDef="select">
                            <th mat-header-cell *matHeaderCellDef
                                class="mat-table-header-style-dark table-header-class"
                                style="width:60px;"></th>
                            <td mat-cell *matCellDef="let element; let tableRowIdx = index;"
                                class="table-row-class-override" style="padding:5px;width:60px;">
                                <img *ngIf="element.select == true" src="../../../../../assets/greenTick.png" style="scale: 80%;">
                            </td>
                        </ng-container>
                        <!-- Id Column -->
                        <ng-container matColumnDef="id" >
                            <th mat-header-cell *matHeaderCellDef
                                class="mat-table-header-style-dark table-header-class"
                                [hidden]="true">Id</th>
                            <td mat-cell *matCellDef="let element" class="table-row-class table-row-class-override"
                                [hidden]="true"> {{element.id}} </td>
                        </ng-container>
                        <!-- description -->

                        <ng-container matColumnDef="description">
                            <th mat-header-cell *matHeaderCellDef
                                class="mat-table-header-style-dark table-header-class"
                                style="width:230px;padding-left: 5px;">
                                Service Types</th>
                            <td mat-cell *matCellDef="let element"
                                style="padding-left:8px;width:230px;"
                                class="table-row-class table-row-class-override"> {{element.description}}
                            </td>
                        </ng-container>

                        <!-- AMOUNT -->
                        <ng-container matColumnDef="amount" >
                            <th mat-header-cell *matHeaderCellDef
                                class="mat-table-header-style-dark table-header-class"
                                style="width:60px;">
                                Amount</th>
                            <td mat-cell *matCellDef="let element; let tableRowIdx = index;"
                                class="table-row-class table-row-class-override">

                                <input *ngIf="selectedRecord?.id == element.id"
                                       matInput type="text" id="idAmount" min="1"
                                       style="width:60px!important; font-size: 9pt;
                                       border: .5px solid gray"
                                       (change)="doChangeAmount($event, tableRowIdx)"
                                       [(ngModel)]="element.amount">

                                <span *ngIf="selectedRecord?.id !== element.id"
                                      style="width:80px!important">{{element.amount}}</span>
                            </td>
                        </ng-container>

                        <!-- Unit Of Measure -->
                        <ng-container matColumnDef="unitOfMeasure" >
                            <th mat-header-cell *matHeaderCellDef
                                class="mat-table-header-style-dark table-header-class"
                                style="width: 100px;"></th>
                            <td mat-cell *matCellDef="let element"
                                class="table-row-class table-row-class-override"
                                style="padding-left:5px; width:100px">
                                {{element.unitOfMeasure}} </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row
                            *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                            [ngClass]="{'row-selected': tableRowIdx == Idx}"
                            (click)="onRowClicked(row)">
                        </tr>
                    </table>
                </div>
            </div>
        </div>
  </div>


    <!----------------------->
    <!-- ERROR LINE --------->
    <!----------------------->
    <div class="error-line error-line-override" *ngIf="strErr.length > 0">{{strErr}}</div>
    <div class="error-line error-line-override-transparent" *ngIf="!strErr.length"></div>
    <!----------------------->
    <!-- SAVE STRIP        -->
    <!----------------------->
    <div class="dwform-row-gap"></div>
    <div class="save-close-strip save-close-strip-override" >

        <button mat-button class="command-button" [disabled]="!submitEnabled"
                (click)="submitRecord()" matTooltip="Save the record"
                mat-button>
            <mat-icon>check_circle_outline</mat-icon>
            Submit
        </button>
        <button mat-button class="command-button"
                (click)="cancelSubmitRecord()" matTooltip="Cancel New Case" mat-button>
            <mat-icon>highlight_off</mat-icon>
            Cancel
        </button>
    </div>
</div>
</div>

<p-dialog header="Important: Please Read" [focusOnShow]="false"
          [(visible)]="showAddNewCaseMsgDlg" [modal]="true"
          [style]="{width: '570px', height: '340px'}"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="false" >
<div class="message-class">
    For a <b>new applicant</b>, the case must be entered in the Universal Application to capture an electronic
    signature for data privacy, rights, and additional information. A case can only be added to an <b>existing client</b>
    case for case related information such as household members and address.
    After adding an additional case to an existing client, send an email to
    <span style="color:blue; text-decoration: underline;">agency@theconnectorwga.org</span>
    using the template: <b>Add Case For Existing Client</b>.

    <br /><br /><b style="font-size: 10pt">Note: Failure to follow these guidelines may result in suspension of user
    access.</b>
    <div style="height:25px;"></div>
    <div class="save-close-strip" style="bottom: 12px;" >

        <button mat-button class="command-button"
                (click)="acceptAddNewRecord()"
                matTooltip="I have read and understood the above statement and wish to proceed"
                mat-button>
            <mat-icon>check_circle_outline</mat-icon>
            Accept
        </button>
        <button mat-button class="command-button"
                (click)="cancelAddNewRecord()" matTooltip="Cancel the new case" mat-button>
            <mat-icon>highlight_off</mat-icon>
            Cancel
        </button>
    </div>

</div>
</p-dialog>



<p-dialog header="Existing members found" [focusOnShow]="false"
          [(visible)]="showExistingMembersDlg" [modal]="true"
          [style]="{width: '580px', height: '460px'}"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="false" >
    <app-existing-members #existingmembers
          (submitClicked)="doMemberSelected($event)"
          (cancelClicked)="doCancelMemberSelected()">
    </app-existing-members>
</p-dialog>
